import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/admin/business/leads/companies/")({
    beforeLoad: ({ search }) => {
        throw redirect({ to: "/sales/leads/companies", search, replace: true });
    },
});
